import styled from 'styled-components';
import { COLORS } from '../../../constants/style/color';
import { rem } from '../../../utils/style';

export const AlertSubscriptionCard = styled.div`
  background: ${COLORS.White};
  box-shadow: 0px 2px 7px ${COLORS.CardShadow};
  border-radius: 6px;
  padding: ${rem(24)};

  .company-select {
    margin-bottom: ${rem(24)};
  }

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${rem(16)};
  }

  .section-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: ${rem(16)};
    padding-top: ${rem(16)};
    border-top: 1px solid ${COLORS.CulturedWhite};
  }
`;

export const SubscriptionTableHeader = styled.div`
  display: grid;
  grid-template-columns: ${rem(250)} ${rem(350)} ${rem(200)} ${rem(100)};
  gap: 0 ${rem(12)};
  padding-bottom: ${rem(8)};
  border-bottom: 1px solid ${COLORS.LightGray};

  & > *:nth-child(3) {
    padding-left: ${rem(8)};
  }
`;

export const SubscriptionTableRow = styled.div`
  display: grid;
  grid-template-columns: ${rem(250)} ${rem(350)} ${rem(200)} ${rem(100)};
  gap: 0 ${rem(12)};
  align-items: start;
  padding: ${rem(10)} 0 ${rem(6)};
  border-bottom: 1px solid ${COLORS.CulturedWhite};

  &:last-child {
    border-bottom: none;
  }

  .select-cell [class*='-control'] {
    min-height: 4.375rem !important;
  }

  .date-cell {
    display: flex;
    align-items: center;
    padding-top: ${rem(10)};
    padding-left: ${rem(8)};
  }

  .action-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: ${rem(8)};

    .delete-icon {
      font-size: ${rem(18)};
      color: ${COLORS.Red};
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }
    }
  }
`;
